var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Change Pin"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24",
    width: 36,
    height: 36,
    rx: 8,
    fill: "url(#paint0_linear_1407_3724)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 14H26C26.5523 14 27 14.4477 27 15V27C27 27.5523 26.5523 28 26 28H10C9.44772 28 9 27.5523 9 27V15C9 14.4477 9.44772 14 10 14H12V13C12 9.68629 14.6863 7 18 7C21.3137 7 24 9.68629 24 13V14ZM22 14V13C22 10.7909 20.2091 9 18 9C15.7909 9 14 10.7909 14 13V14H22ZM17 20V22H19V20H17ZM13 20V22H15V20H13ZM21 20V22H23V20H21Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1407_3724",
    x1: 0,
    y1: 18,
    x2: 36,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB930"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon_pin.a28c8c4eaed3fbc4b894c710095d4d03.svg";
export { ForwardRef as ReactComponent };